export default __webpack_public_path__ + "static/media/six-image.f2714de7.png";